<template>
  <div class="homepage">
    <div class="row">
      <div class="main">
        <Carousel
          :loading="!bannerDataIsReady"
          :data="bannerData"
          :error="bannerDataError"
        />
        <RecentNews
          :loading="!newsDataIsReady"
          :data="newsData"
          :error="newsDataError"
        />
      </div>
      <div class="side">
        <ResearchDirection
          :loading="!researchListIsReady"
          :data="researchList"
          :error="researchListError"
        />
        <RecruitStudents
          :loading="!recruitmentListIsReady"
          :data="recruitmentList"
          :error="recruitmentListError"
          :linksLoading="!linksDataIsReady"
          :linksData="linksData"
          :linksDataError="linksDataError"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import {
  Carousel,
  RecentNews,
  ResearchDirection,
  RecruitStudents
} from 'components/homepage';

export default {
  components: {
    Carousel,
    RecentNews,
    ResearchDirection,
    RecruitStudents
  },
  data() {
    return {
      bannerDataIsReady: false,
      bannerData: [],
      bannerDataError: null,

      newsDataIsReady: false,
      newsData: [],
      newsDataError: null,

      researchListIsReady: false,
      researchList: [],
      researchListError: null,

      linksDataIsReady: false,
      linksData: [],
      linksDataError: null,

      recruitmentListIsReady: false,
      recruitmentList: [],
      recruitmentListError: null,
    };
  },
  mounted() {
    this.getBanner();
    this.getNews();
    this.getResearchList();
    this.getLinks();
    this.getRecruitmentList();
  },
  methods: {
    ...mapActions('homepage', [
      'requestGetBanner',
      'requestGetNews',
      'requestGetLinks',
      'requestGetRecruitmentList',
    ]),
    ...mapActions('research', [
      'requestGetResearchList',
    ]),
    getBanner() {
      this.requestGetBanner()
        .then(data => {
          this.bannerData = data.sort((a, b) => {
            return a.seq - b.seq;
          }).map(item => item.pic.originUri);
          this.bannerDataError = null;
          this.bannerDataIsReady = true;
        })
        .catch(err => {
          this.bannerDataError = err;
          this.bannerDataIsReady = true;
        });
    },
    getNews() {
      this.requestGetNews()
        .then(data => {
          this.newsData = data;
          this.newsDataError = null;
          this.newsDataIsReady = true;
        })
        .catch(err => {
          this.newsDataError = err;
          this.newsDataIsReady = true;
        });
    },
    getResearchList() {
      this.requestGetResearchList()
        .then(data => {
          this.researchList = data;
          this.researchListError = null;
          this.researchListIsReady = true;
        })
        .catch(err => {
          this.researchListError = err;
          this.researchListIsReady = true;
        });
    },
    getLinks() {
      this.requestGetLinks()
        .then(data => {
          this.linksData = data;
          this.linksDataError = null;
          this.linksDataIsReady = true;
        })
        .catch(err => {
          this.linksDataError = err;
          this.linksDataIsReady = true;
        });
    },
    getRecruitmentList() {
      this.requestGetRecruitmentList()
        .then(data => {
          this.recruitmentList = data;
          this.recruitmentListError = null;
          this.recruitmentListIsReady = true;
        })
        .catch(err => {
          this.recruitmentListError = err;
          this.recruitmentListIsReady = true;
        });
    },
  },
}
</script>

<style lang="less" scoped>
  @import url('~@/assets/styles/vars.less');

  .row {
    display: flex;
    justify-content: space-between;
  }
  .main {
    width: 880px;
  }
  .side {
    flex: 1;
    margin-left: 12px;
  }
</style>
